<button type="button" (mouseover)="showInfo()" [disabled]="disabled" class="source-text"
    [style.top]="top ? top: '44%'" [style.right]="right ? right: '15px'"
    [ngClass]="{'active': fieldNote}"
    (click)="openModal(template)" *ngIf="sourceService.getSource(fieldSource, fieldNote)">

  <div class="position: relative">
      {{sourceService.getSource(fieldSource, fieldSourceTitle)}}
      <i class="fa fa-asterisk" *ngIf="sourceService.isOther(fieldSource)"></i>

    <div class="content" *ngIf="visible && fieldNote">
      <div class="row data-row">
        <div class="col-12">
          <label>Notes</label>
          <div class="value notes">{{fieldNote}}</div>
        </div>
      </div>
    </div>
  </div>
</button>

<ng-template #template>
  <form name="form" #f="ngForm" (ngSubmit)="f.form.valid && acceptChanges()">
    <div class="modal-header">
      <h4 class="modal-title pull-left">Edit Source {{headerName?('of '+headerName):''}}</h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <input-search placeholder="Select or Search Soruces" [disabled]="lockService.getLock(fieldName)"
                  [preset]="sourceValues" [inputValue]="tempFieldSource" [searchable]="true" [regular]="true"
                  (valueChange)="sourceValueChanged($event)" [noCancel]="true"></input-search>

    <!--   <select name="selectedSource" class="form-control rounded-0" [(ngModel)]="tempFieldSource" [disabled]="lockService.getLock(fieldName)">
        <option *ngFor="let source of sourceService.getSources(); let i = index" [value]="source.SOURCE_CODE">{{source.SOURCE_NAME}}</option>
      </select> -->
      <textarea rows="5" class="form-control rounded-0" placeholder="Description / Notes of Selected Source" name="sourceDesc"
        [(ngModel)]="tempFieldNote" [readonly]="lockService.getLock(fieldName)"></textarea>

      <input *ngIf="tempFieldSource == 'OTH'" type="text" class="form-control rounded-0 mt-2" placeholder="Source of Document Title" name="sourceTitle"
        [(ngModel)]="tempFieldSourceTitle" required/>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-rbv default" (click)="modalRef.hide()">Cancel</button>
        <button type="submit" class="btn btn-rbv" *ngIf="!lockService.getLock(fieldName)" [disabled]="!f.form.valid">Accept Changes</button>
      </div>

  </form>
</ng-template>
